"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgPrimaryPay = function SvgPrimaryPay(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 504 194",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M11.328 158.224L15.718 194h153.733l-5.031-40.972H92.743l-.626-5.077 66.019-46.134-4.411-35.848H0l5.03 40.971h71.796l.633 5.124-66.132 46.16z",
      fill: "#1A0826"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M171.587 65.969L187.306 194h153.85L325.438 65.969H171.587z",
      fill: theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M502.497 112.064c-3.547-28.78-26.156-46.22-56.882-46.095H343.286l15.712 128.025h46.035l-3.152-25.603H450.6c38.354 0 55.899-23.894 51.897-56.327zm-56.862 20.44l-48.132.052-3.771-30.725 48.402.04c11.387.131 17.209 6.54 18.145 15.316.58 5.637-2.004 15.31-14.644 15.31v.007z",
      fill: "#1A0826"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M222.4 48.926c8.097-8.692 6.686-23.168-3.152-32.333-9.839-9.164-24.378-9.546-32.475-.854-8.097 8.693-6.686 23.168 3.152 32.333 9.839 9.164 24.378 9.547 32.475.854z",
      fill: "#000"
    })]
  }));
};

var _default = SvgPrimaryPay;
exports["default"] = _default;